export default "__VITE_ASSET__ca674fef__"